// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-nav-urls ul{margin:0;padding:0;list-style:none}.filter-nav-urls ul li{margin:0;padding:0}.filter-nav-urls ul li .url-item-btn{display:inline-block;letter-spacing:.5px;outline:none;border:none;background:transparent;padding:8px 0;color:#979797;transition:color .4s ease;text-decoration:none}.filter-nav-urls ul li .url-item-btn.active,.filter-nav-urls ul li .url-item-btn:hover{color:#1e1e1e;font-weight:400}", ""]);
// Exports
module.exports = exports;
